import "Layouts/default";

import { initAnchors } from "Functions/anchor";

import "Common/lightgallery";
import "Common/social";

import "Ui/slider";
import "Ui/shorten";

document.addEventListener("DOMContentLoaded", function () {
    initAnchors();
});
